// Per-tab property pin.
//
// The user doc has ONE `active_property_id`, shared by every open window.
// On the multi-property admin account, switching to Gringo Gazette South
// in one window used to re-scope every other window on the server while
// those windows kept showing "Gringo Gazette North" — so a publish from a
// North-labelled window could land on South.
//
// Each browser tab now pins its own property in sessionStorage (per tab,
// survives reloads, gone when the tab closes). AuthProvider sends it on
// every request as `X-Property-Id`; the backend honours it only if the
// account has that property (backend/property_scope.py). A brand-new tab
// has no pin yet and starts on the account's last-switched property.

export const TAB_PROPERTY_KEY = "newsdesk.tabPropertyId";

// Pure: which property should this tab use?
//   1. its own pin, if the account still has that property
//   2. the server's active property, if the account still has it
//   3. the first property on the account
//   4. null (no properties assigned)
export function resolveTabPropertyId({ allowed, serverActive, pinned }) {
  const ids = Array.isArray(allowed)
    ? allowed.filter((id) => typeof id === "string" && id)
    : [];
  if (pinned && ids.includes(pinned)) return pinned;
  if (serverActive && ids.includes(serverActive)) return serverActive;
  return ids[0] || null;
}

export function readPinnedPropertyId() {
  try {
    return window.sessionStorage.getItem(TAB_PROPERTY_KEY) || "";
  } catch {
    return ""; // storage blocked — fall back to server behaviour
  }
}

export function writePinnedPropertyId(id) {
  try {
    if (id) window.sessionStorage.setItem(TAB_PROPERTY_KEY, id);
    else window.sessionStorage.removeItem(TAB_PROPERTY_KEY);
  } catch {
    /* storage blocked — nothing to persist */
  }
}